// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"37":"3ed57b74","412":"fcf1524c","596":"79f0d3f4","619":"df7a22bb","923":"8f394da4"}[chunkId] + ".js";
};